<div class="banner d-none d-lg-block">
  <div class="container h-100 d-flex align-items-center">
    <ng-container *ngIf="isHomePage; else normalBanner">
      <div class="banner-content d-flex flex-column justify-content-center h-100 gap-1">
        <h1 class="banner-home-title" *ngIf="memberDetails$ | async as memberDetails">
          {{ 'WELCOME, ' + memberDetails?.FirstName }}
        </h1>

        <div class="d-flex font-size-14" *ngIf="memberCard$ | async as memberCard">
          <div class="product-code text-white">{{ memberCard?.ProductCode }} - {{ memberCard?.ExternalRefNumber }}</div>
        </div>
      </div>
    </ng-container>

    <ng-template #normalBanner>
      <h1 class="banner-title">
        {{ title }}
      </h1>
    </ng-template>
  </div>
</div>
